import AccountIcon from '@mui/icons-material/AccountCircle'
import CampaignIcon from '@mui/icons-material/Campaign'
import EmailIcon from '@mui/icons-material/Email'
import FilterIcon from '@mui/icons-material/Filter'
import MessageIcon from '@mui/icons-material/Message'
import PhoneIcon from '@mui/icons-material/Phone'
import { ROUTES_PATH } from './routes'

export const ADMIN_CONTACT_EMAIL = 'test@esc-testing.com'

export const SIDEBAR_ITEMS = [
  {
    title: 'Account Manager',
    icon: AccountIcon,
    href: ROUTES_PATH.ACCOUNT_MANAGER,
    key: 'accountManager'
  },
  {
    title: 'Campaigns',
    icon: CampaignIcon,
    href: ROUTES_PATH.CAMPAIGNS,
    key: 'campaignManager'
  },
  {
    title: 'Assets',
    icon: FilterIcon,
    href: ROUTES_PATH.ASSETS,
    key: 'assetManager'
  }
]

export const WEB_SIDEBAR_ITEMS = [
  {
    title: 'Account Viewer',
    icon: AccountIcon,
    href: ROUTES_PATH.ACCOUNT_MANAGER,
    key: 'accountManager'
  }
]

export const WEB_TOPBAR_ITEMS = [
  { title: 'Account Viewer', icon: AccountIcon, href: ROUTES_PATH.DASHBOARD },
  { title: 'Account Viewer', icon: AccountIcon, href: ROUTES_PATH.ACCOUNT_MANAGER },
  { title: 'Account Viewer', icon: FilterIcon, href: ROUTES_PATH.ACCOUNT_DETAILS }
]

export const TOPBAR_ITEMS = [
  { title: 'Account Manager', icon: AccountIcon, href: ROUTES_PATH.DASHBOARD },
  { title: 'Account Manager', icon: AccountIcon, href: ROUTES_PATH.ACCOUNT_MANAGER },
  { title: 'Campaign Manager', icon: CampaignIcon, href: ROUTES_PATH.CAMPAIGNS },
  { title: 'Campaign Manager', icon: CampaignIcon, href: ROUTES_PATH.CAMPAIGN_LOGS },
  { title: 'Assets Manager', icon: FilterIcon, href: ROUTES_PATH.ASSETS },
  { title: 'Account Manager', icon: FilterIcon, href: ROUTES_PATH.ACCOUNT_DETAILS }
]

export const CAMPAIGN_ACCORDION_ITEMS = [
  {
    templateType: 'text',
    header: 'Text Message',
    icon: MessageIcon
  },
  {
    templateType: 'email',
    header: 'Email Message',
    icon: EmailIcon
  },
  {
    templateType: 'voice',
    header: 'Voice Message',
    icon: PhoneIcon
  }
]

export const MESSAGES = {
  WRONG_ERROR: 'Oops, an unexpected error occurred.',
  FAILED_VERIFYING_ACCOUNT: 'Failed verifying account'
}

export enum CLIENT {
  NEP = 'nep',
  DELCO = 'delco',
  MVU = 'mvu',
  AR = 'ar',
  WEB = 'web',
  CARMEL = 'carmel'
};
